import type { Config } from '../../../../../components/ladda-react';
import { withData as pureWithData } from '../../../../../components/ladda-react';
import RouteError from '../../../routing/RouteError';
import LoadingIndicatorFull from '../../components/LoadingIndicatorFull';

export function withPageData<InjectedProps, ResolverArguments, ErrorType = any>(
    conf: Config<InjectedProps, ResolverArguments, ErrorType>
) {
    return pureWithData<InjectedProps, ResolverArguments, ErrorType>({
        pendingComponent: () => <LoadingIndicatorFull />,
        errorComponent: RouteError,
        ...conf,
    });
}

withPageData.PAGINATION = pureWithData.PAGINATION;
